var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDash3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 37.5,
    viewBox: "0 0 50 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 -6.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M18.75,25a9.375,9.375,0,1,0-9.375-9.375A9.375,9.375,0,0,0,18.75,25ZM3.125,43.75A3.061,3.061,0,0,1,0,40.625c0-3.125,3.125-12.5,18.75-12.5S37.5,37.5,37.5,40.625a3.061,3.061,0,0,1-3.125,3.125Zm31.25-32.812a1.562,1.562,0,0,1,1.563-1.562h12.5a1.563,1.563,0,0,1,0,3.125h-12.5A1.562,1.562,0,0,1,34.375,10.938Zm1.563,7.813a1.563,1.563,0,0,0,0,3.125h12.5a1.563,1.563,0,0,0,0-3.125Zm6.25,9.375a1.562,1.562,0,0,0,0,3.125h6.25a1.563,1.563,0,0,0,0-3.125Zm0,9.375a1.563,1.563,0,0,0,0,3.125h6.25a1.563,1.563,0,0,0,0-3.125Z",
    fill: "#cc6b16"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash3);
export default __webpack_public_path__ + "static/media/dash3.c170987378760dc9a700cf5a407b6b28.svg";
export { ForwardRef as ReactComponent };